import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

import logo from "../../assets/image/Frame.png";
import profile from "../../assets/image/guest.png";
import fire from "../../assets/image/fire1.png";
import comment from "../../assets/image/comment.png";
import folder from "../../assets/image/folder.png";
import address from "../../assets/image/address.png";
import leo from "../../assets/image/Leo.jpg";

import { getCompletedService } from "../../helpers/getCompletedService";
import { getCompletedPersonService } from "../../helpers/getCompletedPersonService";
import { MainContext } from "../../context/MainContext";
import getWorkingDays from "../../helpers/getWorkingDays";

function Main() {
  const { markers, action, ordersCurrent, ordersResolved, user } = useContext(MainContext);
  const navigate = useNavigate();

  const [count, setCount] = useState({});
  const [arrayAction, setArrayAction] = useState([]);

  const workingDays = getWorkingDays();
  const { total, completed, remains, completedObj } = getCompletedPersonService({ markers, user });

  useEffect(() => {
    const result = getCompletedService(markers);
    setCount(result);
  }, [markers]);

  useEffect(() => {
    if (!action) return;

    const newArray = [];
    action.forEach((elem) => {
      if (elem.type !== "entry user") {
        elem.actions.forEach((item) => {
          newArray.push(item);
        });
      }
    });

    newArray.sort((a, b) => {
      const parseDate = (str) => {
        const [datePart, timePart] = str.split(" ");
        const [day, month, year] = datePart.split(".").map(Number);
        const [hours, minutes] = timePart.split(":").map(Number);
        return new Date(year, month - 1, day, hours, minutes);
      };

      return parseDate(a.time) - parseDate(b.time);
    });

    setArrayAction(newArray);
  }, [action]);

  const result = count?.remainingCount / workingDays;

  const handleRouteObject = () => {
    navigate("/objects");
  };
  const handleRouteSlider = () => {
    navigate("/slider");
  };
  const handleRouteComment = () => {
    navigate("/comment");
  };

  const handleRouteOrdersPage = () => {
    navigate("/orders");
  };

  return (
    <div className={styles.main}>
      <div className={styles.objects__banner}>
        <div className={styles.objects__banner__content}>
          <img className={styles.objects__banner__logo} src={logo} alt="logo" />
          <div>
            <h3 className={styles.objects__banner__content_title}>FIRE SAFETY</h3>
            <p className={styles.objects__banner__content_text}>Center</p>
          </div>
        </div>
        <div className={styles.main__profile}>
          <img className={styles.main__profile__img} src={profile} alt="User Profile" />
        </div>
      </div>
      <div className={styles.main__card}>
        <div className={styles.main__card__statistics}>
          <div className={styles.main__card__statistics__top}>
            <h3 className={styles.main__card__statistics__top_title}>Статистика</h3>
            <div className={styles.main__card__statistics__top_info}>
              {count?.currentMonth?.count} / {count?.completionPercentage}%
            </div>
          </div>
          <div className={styles.main__card__statistics__bottom_container}>
            {user.data.main_id.length > 0 && (
              <div className={styles.main__card__statistics__bottom__person}>
                <div
                  className={styles.main__card__statistics__bottom__person_box}
                  style={{ borderRight: "1px solid #e0e0e0", paddingRight: "2px" }}
                >
                  <span>мои</span>
                  <span>объекты</span>
                </div>
                <div
                  className={styles.main__card__statistics__bottom__person_box}
                  style={{ borderRight: "1px solid #e0e0e0", paddingRight: "2px" }}
                >
                  <span>Всего</span>
                  <span>{total}</span>
                </div>
                <div
                  className={styles.main__card__statistics__bottom__person_box}
                  style={{ borderRight: "1px solid #e0e0e0", paddingRight: "2px" }}
                >
                  <span>Выполнено</span>
                  <span>{completed}</span>
                </div>
                <div className={styles.main__card__statistics__bottom__person_box}>
                  <span>Осталось</span>
                  <span>{remains}</span>
                </div>
              </div>
            )}
            <div className={styles.main__card__statistics__bottom}>
              <span
                className={styles.main__card__statistics__bottom_span}
                style={{ borderRight: "1px solid #e0e0e0", paddingRight: "2px" }}
              >
                <h3 className={styles.main__card__statistics__bottom_span_title}>{workingDays}</h3>
                <p className={styles.main__card__statistics__bottom_span_text}>
                  Осталось рабочих дней
                </p>
              </span>
              <span
                className={styles.main__card__statistics__bottom_span}
                style={{ padding: "0 2px" }}
              >
                <h3 className={styles.main__card__statistics__bottom_span_title}>
                  {count?.remainingCount}
                </h3>
                <p className={styles.main__card__statistics__bottom_span_text}>Оставшиеся ТО</p>
              </span>
              <span
                className={styles.main__card__statistics__bottom_span}
                style={{ borderLeft: "1px solid #e0e0e0", paddingLeft: "2px" }}
              >
                <h3 className={styles.main__card__statistics__bottom_span_title}>
                  {result.toFixed(1)}
                </h3>
                <p className={styles.main__card__statistics__bottom_span_text}>
                  Проверок на сегодня
                </p>
              </span>
            </div>
          </div>
        </div>
        <div className={styles.main__card__orders}>
          <div className={styles.main__card__orders__top}>
            <h3 className={styles.main__card__orders__top_title}>Заявки</h3>
          </div>
          <div className={styles.main__card__orders__bottom}>
            {ordersCurrent.length > 0 ? (
              arrayAction
                .slice(-3) // берем последние 3 элемента
                .map((item) => (
                  <div className={styles.main__card__orders__bottom_item} key={item.id}>
                    {item.name || `Заявка #${item.id}`}
                  </div>
                ))
            ) : (
              <div className={styles.main__card__orders__bottom__empty}>
                <p className={styles.main__card__orders__bottom__empty_text}>
                  Заявки отсутствуют вы можете создать новую
                </p>
                <button
                  className={styles.main__card__orders__bottom__empty_btn}
                  onClick={handleRouteOrdersPage}
                >
                  Перейти
                </button>
              </div>
            )}
          </div>
        </div>
        <div className={styles.main__card__service}>
          <h3 className={styles.main__card__service__title}>Сервис</h3>
          <div className={styles.main__card__service__container}>
            <span className={styles.main__card__service__item}>
              <div className={styles.main__card__service__item__box}>
                <img
                  className={styles.main__card__service__item__box__img}
                  src={address}
                  alt="address"
                />
              </div>
              <button className={styles.main__card__service__item__btn} onClick={handleRouteObject}>
                <p className={styles.main__card__service__item__btn__title}>Объекты</p>
                <p className={styles.main__card__service__item__btn__arrow}>→</p>
              </button>
            </span>
            <span className={styles.main__card__service__item}>
              <div className={styles.main__card__service__item__box}>
                <img className={styles.main__card__service__item__box__img} src={fire} alt="fire" />
              </div>
              <button className={styles.main__card__service__item__btn} onClick={handleRouteSlider}>
                <p className={styles.main__card__service__item__btn__title}>Выполненые ТО</p>
                <p className={styles.main__card__service__item__btn__arrow}>→</p>
              </button>
            </span>
            <span className={styles.main__card__service__item}>
              <div className={styles.main__card__service__item__box}>
                <img
                  className={styles.main__card__service__item__box__img}
                  src={comment}
                  alt="comment"
                />
              </div>
              <button
                className={styles.main__card__service__item__btn}
                onClick={handleRouteComment}
              >
                <p className={styles.main__card__service__item__btn__title}>Коментарии</p>
                <p className={styles.main__card__service__item__btn__arrow}>→</p>
              </button>
            </span>
            <span className={styles.main__card__service__item}>
              <div className={styles.main__card__service__item__box}>
                <img
                  className={styles.main__card__service__item__box__img}
                  src={folder}
                  alt="folder"
                />
              </div>
              <button className={styles.main__card__service__item__btn}>
                <p className={styles.main__card__service__item__btn__title}>Teх.Документация</p>
                <p className={styles.main__card__service__item__btn__arrow}>→</p>
              </button>
            </span>
          </div>
        </div>
        <div className={styles.main__card__notification} style={{ marginBottom: "150px" }}>
          <div className={styles.main__card__notification__top}>
            <h3 className={styles.main__card__notification__top_title}>Уведомления</h3>
          </div>
          <div className={styles.main__card__notification__bottom}>
            {arrayAction.length > 0 &&
              arrayAction.slice(-3).map((item, index) => (
                <div key={index}>
                  {item.typeName === "service" && (
                    <div className={styles.main__card__notification__bottom__container}>
                      <img
                        className={styles.main__card__notification__bottom__img}
                        src={leo}
                        alt="leo"
                      />
                      <div className={styles.main__card__notification__bottom__wrapper}>
                        <span className={styles.main__card__notification__bottom__title}>
                          {item.nameObj}
                        </span>
                        <span className={styles.main__card__notification__bottom__box}>
                          <p>дата: {item.time}</p>
                          <p className={styles.main__card__notification__bottom__box__text}>
                            Добавлено ТО
                          </p>
                        </span>
                      </div>
                    </div>
                  )}
                  {item.typeName === "info" && (
                    <div className={styles.main__card__notification__bottom__container}>
                      <img
                        className={styles.main__card__notification__bottom__img}
                        src={leo}
                        alt="leo"
                      />
                      <div className={styles.main__card__notification__bottom__wrapper}>
                        <span className={styles.main__card__notification__bottom__title}>
                          {item.nameObj}
                        </span>
                        <span className={styles.main__card__notification__bottom__box}>
                          <p>дата: {item.time}</p>
                          <p className={styles.main__card__notification__bottom__box__text}>
                            Добавлен телефон
                          </p>
                        </span>
                      </div>
                    </div>
                  )}
                  {item.typeName === "comment" && (
                    <div className={styles.main__card__notification__bottom__container}>
                      <img
                        className={styles.main__card__notification__bottom__img}
                        src={leo}
                        alt="leo"
                      />
                      <div className={styles.main__card__notification__bottom__wrapper}>
                        <span className={styles.main__card__notification__bottom__title}>
                          {item.nameObj}
                        </span>
                        <span className={styles.main__card__notification__bottom__box}>
                          <p>дата: {item.time}</p>
                          <p className={styles.main__card__notification__bottom__box__text}>
                            Новый коментарий
                          </p>
                        </span>
                      </div>
                    </div>
                  )}
                  {item.typeName === "repair" && (
                    <div className={styles.main__card__notification__bottom__container}>
                      <img
                        className={styles.main__card__notification__bottom__img}
                        src={leo}
                        alt="leo"
                      />
                      <div className={styles.main__card__notification__bottom__wrapper}>
                        <span className={styles.main__card__notification__bottom__title}>
                          {item.nameObj}
                        </span>
                        <span className={styles.main__card__notification__bottom__box}>
                          <p>дата: {item.time}</p>
                          <p className={styles.main__card__notification__bottom__box__text}>
                            Ремонт
                          </p>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
